(function () {
  if (!window.lifeLangForeign) return;

  var shopPaths = {};
  (window.lifeShopUrls || []).forEach(function (u) {
    if (u) shopPaths[decodeURIComponent(u).replace(/\/$/, '')] = 1;
  });

  function isShopLink(a) {
    var href = a.getAttribute('href') || '';
    if (/\/products\/box[-_]|\/pages\/(acquista-ora|box)\b/i.test(href)) return true;
    var path;
    try { path = decodeURIComponent(new URL(href, location.href).pathname).replace(/\/$/, ''); } catch (e) { return false; }
    return !!shopPaths[path];
  }

  function hideBoxHits(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var links = scope.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      if (!isShopLink(links[i])) continue;
      var target =
        links[i].closest(
          '.card-wrapper, .predictive-search__result, .predictive-search__item, li.grid__item, .grid__item, article, .life-hero__btn-wrap, .life-header__item--cta'
        ) || links[i];
      target.style.setProperty('display', 'none', 'important');
    }
  }

  function apply() {
    hideBoxHits(document);
  }

  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', apply);

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      for (var j = 0; j < records[i].addedNodes.length; j++) {
        var n = records[i].addedNodes[j];
        if (n.nodeType === 1) hideBoxHits(n.parentNode || n);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
